import React, { Component } from "react";
import axiosInstance from "../../api/utils/axiosInstance";

export default class Kontakt extends Component {
  state = {
    email: "",
    tel: "",
    emailPodrska: "",
    telPodrska: "",
  };

  componentDidMount = () => {
    axiosInstance.get("/mfin-kontakt").then((res) => {
      this.setState({
        email: res.data.email,
        tel: res.data.tel,
        emailPodrska: res.data.emailPodrska,
        telPodrska: res.data.telPodrska
      });
    });
  };

  render() {
    return (
      <>
        <div
          style={{ padding: "60px", textAlign: "center" }}
          className="kontakt"
        >
          <h4 className="mb-3">Ministarstvo financija</h4>
          <p className="subtitle" style={{ marginBottom: "28px" }}>
            Samostalni sektor za izdavanje odobrenja za rad i nadzor ovlaštenih
            revizora i revizorskih društava
          </p>
          <div style={{ marginBottom: "1rem" }}>
            <strong>e&#8209;mail: </strong>
            <a href={`mailto:` + `${this.state.email}`}>{this.state.email}</a>
          </div>
          <div style={{ marginBottom: "2rem" }}>
            <strong>tel: </strong>{" "}
            <a href={`tel:` + `${this.state.tel}`}> {this.state.tel}</a>
          </div>
          <p className="subtitle" style={{ marginBottom: "28px" }}>
            Tehnička pomoć u radu aplikacije (dostupnost aplikacije, potpisni modul)
          </p>
          <div style={{ marginBottom: "1rem" }}>
            <strong>e&#8209;mail: </strong>
            <a href={`mailto:` + `${this.state.emailPodrska}`}>{this.state.emailPodrska}</a>
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <strong>tel: </strong>{" "}
            <a href={`tel:` + `${this.state.telPodrska}`}> {this.state.telPodrska}</a>
          </div>
        </div>
      </>
    );
  }
}
